module.exports = "/_next/static/images/CompanyHistory-202679ec22703e683307cfb47ce559fb.jpg.webp";